import { Icon as ChakraIcon } from "@chakra-ui/react"

import { FaHome, FaUser, FaTrophy, FaNetworkWired, FaStore, FaList, FaRegCheckCircle, FaWhatsapp, FaDirections, FaRegUser, FaCopyright } from 'react-icons/fa'
import { MdGroups, MdLabel, MdDarkMode, MdLightMode, MdLogout, MdOutlineVisibility, MdOutlineVisibilityOff, MdCancel, MdOutlineFileUpload, MdAddCircle, MdRemoveCircle, MdOutlineSupervisedUserCircle, MdOutlineLocalShipping, MdOutlineMail, MdOutlineEdit, MdOutlinePix, MdOutlineSupportAgent, MdCached } from "react-icons/md"
import { AiFillBank } from "react-icons/ai"
import { BiMoneyWithdraw } from "react-icons/bi"
import { TbMoneybag, TbReload } from "react-icons/tb"
import { RiEmotionLine } from "react-icons/ri"
import {
    IoTimeOutline,
    IoCloseCircleOutline,
    IoBagHandleOutline,
    IoOpenOutline,
    IoHomeOutline,
    IoSearchOutline,
    IoKeyOutline,
    IoCameraOutline,
    IoAlertCircleOutline,
    IoDiscOutline,
    IoMenu,
    IoShareSocialOutline,
    IoAttach,
    IoStorefrontOutline,
    IoCalendar, IoBoat, IoBoatSharp, IoCart, IoExit
} from "react-icons/io5"
import { FiTrash2 } from "react-icons/fi"
import { LuTimer } from "react-icons/lu"
import { CiCircleInfo } from "react-icons/ci"
import { IoIosArrowRoundForward, IoIosArrowRoundBack, IoIosLink } from "react-icons/io"
import { SiMercadopago } from "react-icons/si"
import { HiAdjustmentsHorizontal } from "react-icons/hi2"
import { PiIdentificationBadge } from "react-icons/pi"

export default function Icon({ name, ...props }){

    let icon;

    switch(name){
        default: case 'home': icon = IoHomeOutline; break;
        case 'menu': icon = IoMenu; break;
        case 'support': icon = MdOutlineSupportAgent; break;
        case 'share': icon = IoShareSocialOutline; break;
        case 'settings': case 'config': case 'adjusts': icon = HiAdjustmentsHorizontal; break;
        case 'profile': case 'user': icon = FaRegUser; break;
        case 'bank': icon = AiFillBank; break;
        case 'cache': icon = MdCached; break;
        case 'withdraw': icon = BiMoneyWithdraw; break;
        case 'bonus': icon = TbMoneybag; break;
        case 'network': icon = FaNetworkWired; break;
        case 'points': case 'point': icon = FaTrophy; break;
        case 'anticipation': case 'anticipations': icon = TbReload; break;
        case 'third': icon = MdGroups; break;
        case 'store': icon = FaStore; break;
        case 'order': case 'orders': icon = FaList; break;
        case 'voucher': case 'vouchers': icon = MdLabel; break;
        case 'dark': icon = MdDarkMode; break;
        case 'light': icon = MdLightMode; break;
        case 'logout': icon = MdLogout; break;
        case 'active': icon = RiEmotionLine; break;
        case 'visible': icon = MdOutlineVisibility; break;
        case 'hidden': icon = MdOutlineVisibilityOff; break;
        case 'cancel': case 'canceled': icon = MdCancel; break;
        case 'waiting': icon = IoTimeOutline; break;
        case 'trash': icon = FiTrash2; break;
        case 'check': case 'done': icon = FaRegCheckCircle; break;
        case 'close': icon = IoCloseCircleOutline; break;
        case 'upload': icon = MdOutlineFileUpload; break;
        case 'timer': icon = LuTimer; break;
        case 'add': icon = MdAddCircle; break;
        case 'remove': icon = MdRemoveCircle; break;
        case 'info': icon = CiCircleInfo; break;
        case 'search': icon = IoSearchOutline; break;
        case 'edit': icon = MdOutlineEdit; break;
        case 'mercadopago': icon = SiMercadopago; break;
        case 'cielo': icon = FaCopyright; break;
        case 'whatsapp': icon = FaWhatsapp; break;
        case 'directions': icon = FaDirections; break;
        case 'popup': icon = IoOpenOutline; break;
        case 'attach': icon = IoAttach; break;
        case 'link': icon = IoIosLink; break;
        case 'pix': icon = MdOutlinePix; break;
        case 'key': case 'pix_key': icon = IoKeyOutline; break;
        case 'camera': icon = IoCameraOutline; break;
        case 'alert': icon = IoAlertCircleOutline; break;
        case 'analyzing': icon = IoDiscOutline; break;
        case 'identity': icon = PiIdentificationBadge; break;
        case 'mail': case 'email': icon = MdOutlineMail; break;
        case 'shipping': case 'transit': icon = MdOutlineLocalShipping; break;
        case 'third': icon = MdOutlineSupervisedUserCircle; break;
        case 'distributor': icon = IoStorefrontOutline; break;
        case 'cart': case 'bag': icon = IoBagHandleOutline; break;
        case 'right': case 'next': icon = IoIosArrowRoundForward; break;
        case 'left': case 'prev': icon = IoIosArrowRoundBack; break;
        case 'calendar': case 'date': icon = IoCalendar; break;
        case 'boat': case 'boat_bnf': icon = IoBoatSharp; break;
        case 'cart-shopp': case 'cart_shopp': icon = IoCart; break;
        case 'exit': case 'exit': icon = IoExit; break;
    }
    
    return <ChakraIcon as={icon} {...props} />
}